 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_vi","52":"lang_zh_cn","53":"lang_zh_tw","54":"locale_ak","55":"locale_ar","56":"locale_be","57":"locale_bg","58":"locale_bs","59":"locale_ca","60":"locale_cs","61":"locale_da","62":"locale_de","63":"locale_el","64":"locale_en","65":"locale_es","66":"locale_et","67":"locale_fi","68":"locale_fil","69":"locale_fr","70":"locale_he","71":"locale_hi","72":"locale_hr","73":"locale_hu","74":"locale_id","75":"locale_is","76":"locale_it","77":"locale_ja","78":"locale_ka","79":"locale_kk","80":"locale_ko","81":"locale_ky","82":"locale_lt","83":"locale_lv","84":"locale_nl","85":"locale_pa","86":"locale_pl","87":"locale_pt","88":"locale_ro","89":"locale_ru","90":"locale_sk","91":"locale_sl","92":"locale_sq","93":"locale_sr","94":"locale_sr_cyrl_me","95":"locale_sv","96":"locale_sw","97":"locale_th","98":"locale_tr","99":"locale_uk","100":"locale_ur","101":"locale_vi","102":"locale_zh","103":"loclae_af","104":"polyfills","105":"pubnub","107":"vendors~polyfills","108":"vendors~pubnub"}[chunkId]||chunkId) + "." + {"0":"9270063b09af43e66c89","2":"8f28fccd6c56b48bf1b7","3":"97b7b5e77412db006a37","4":"9a62d8449eb260b0041a","5":"e28694675a4e76989a35","6":"585fcbe41818de162bbc","7":"105fe339b56f0bf526e1","8":"bcc29882a21fc8995c7b","9":"d5d01aad0871be02707d","10":"607f7a15099d36719c9a","11":"7b292e42b99bad02086b","12":"d567859feb8e40573862","13":"f87e34a492bfbb2253c6","14":"8367fbbb1d36837e2dd0","15":"d9667cbbc3cb18bc021a","16":"d6009a8fa5ea1573494c","17":"ea86c03e22da16b05d92","18":"a27d77ff77fcd7ef7308","19":"352507a289c4bc470ead","20":"36472f641320bb8cb4d5","21":"4dbfb8a1e024dd7f7d54","22":"0406ae5d8702315214eb","23":"578de9e2e4ed40c72430","24":"3135aa020bcca29a317c","25":"4bf1b5f41d9ffa72c897","26":"8ea36d0588097408efd6","27":"3910037c607473db650d","28":"fd7ffbb9a2c39e0b3577","29":"ade474a7c5bda63171f3","30":"5c1a8ff767acd3b540f0","31":"9805bc92d31f5ccce37d","32":"ffd61aa029fc010d1f46","33":"dd70edefb54ad42d70ec","34":"a20f167d4df7f9b4875a","35":"b5c02d411cb80eab600a","36":"bbee8233595dfb434e5c","37":"896c1765128dd05dd6e1","38":"bfa54e69d830c4188622","39":"10497b8fd0e148ead083","40":"f28814d1af5fbdb128f0","41":"22d9fa19636a08b5b8d1","42":"e18cab2b6ccae14df9c4","43":"d693419f9940e3deec48","44":"a052ef21e7c002d3e6fa","45":"1486b0885c06ac3ccd4a","46":"3afeb9a5384b4592ea77","47":"742f3e5eb33d06b3ca5c","48":"bbaaa5b9ff381b64bcd7","49":"c7c5731339c36eb222e4","50":"ab2d4aa45cf9741d5792","51":"0b7949f5bebd13f65c12","52":"d24a3f11f1fcd18e7cfe","53":"bece4bed796dad48601b","54":"9e11766d1bd11b87878e","55":"3043781965fd5e96f6d8","56":"3fab0a389d0cdbeddff2","57":"da0bc7d7b0ceb8ced824","58":"3be04bdc380a4eaf0c12","59":"db9459c2bf9e22b16905","60":"ab0bc8470d20ca41f21d","61":"cfa4f77b28b0cb91189e","62":"96f93dcb08812b1282f9","63":"b88dc495b8e2ac8b772e","64":"03fb4b29173907421e76","65":"5558110deac2cd61fda9","66":"ec86423983fd0cb5a308","67":"2f54dd5434991d8ded97","68":"3a2ab68f1f1ccdfc2d96","69":"4b9cd14c08dc6e0fa82c","70":"783a8356d2c2a49082aa","71":"bd3bc21d627fbd2643e2","72":"f671cccf510c957b6970","73":"a1c86cb35800dc9527e7","74":"c39c239f687708b41df0","75":"7dc0a9d89eeb3998becd","76":"b27377472e6586fe0409","77":"2852a2e3b89d5643663f","78":"bfe2316978efac6a37fd","79":"c80715fad9f1e9a37f97","80":"1a08128549315d98356a","81":"705cdf094ca76c892ac7","82":"f6b0c56e2a31d0a11eed","83":"faa851d08d0dd2671dab","84":"d722e7a5043a977fd058","85":"f52a7d36c26deb503c7c","86":"d98caa77fe86485f3203","87":"fff1d31060ef9df9fb7c","88":"6a037499964049b13497","89":"526d40f916addacebb44","90":"950982a1ea08ec0faa5a","91":"ad80cd42e27cb1e52801","92":"272f0d892de84db3324c","93":"17258b69a5b76ab46939","94":"22dbb78f0779e895e158","95":"44435ae609be40edb4a0","96":"fc6006fc619387031ad7","97":"98774ba1ea891f89d17b","98":"9fddf59ad07521a7e510","99":"b438296fa6acc4bdddb6","100":"e288b7bb09032a2eedbf","101":"b787b305d67da856a582","102":"ac2d043610cb3ab7b9c3","103":"ab92ed3b3820f278d989","104":"8153533e8fee61685609","105":"336e0b0460ed1ac8eb85","107":"58030f0e0900f6dc4df1","108":"a05ecdafbd4d8fc21399"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 82);
